import { forwardRef } from 'react';
import { useState, useEffect } from 'react';
import { Select, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import API from '@utils/axios';

const TemplateSelect = forwardRef(({ emptyLabel, ...params }, ref) => {
    const { t } = useTranslation();
    const [templates, setTemplates] = useState([]);

    // Chargement de la liste des templates possibles pour les emails
    useEffect(() => {
        const fetchTemplates = async () => {
            try {
                const response = await API.get('/messages/templates');
                if (response.data) {
                    setTemplates(response.data);
                } else {
                    setTemplates([]);
                }
            } catch (error) {
                setTemplates([]);
            }
        };
        fetchTemplates();
    }, []);

    return (
        <Select ref={ref} {...params} >
            {emptyLabel && <MenuItem value="">{emptyLabel}</MenuItem>}
            {templates.map((template) => (
                <MenuItem key={template.key} value={template.key}>
                    {t(`template.${template.key}`)}
                </MenuItem>
            ))}
        </Select>
    );
});

export default TemplateSelect;